import type { OmpCallConfig, OmpTransport } from "@omega/omp-api";
import { ompApiClient } from "@app/config/axios/clients/ompApiClient";

/**
 * Адаптер `@omega/omp-api` поверх приложения `ompApiClient`.
 *
 * Транспорт владеет base URL, AuthToken, сессией и обработкой OMP-ошибок;
 * пакет контрактов знает только имена методов и wire-формат.
 */
export const ompTransport: OmpTransport = {
    post: <TResponse = unknown>(method: string, body: unknown, config?: OmpCallConfig) =>
        ompApiClient.postOmega<TResponse>(method, body, config),
};
